import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { formatARS } from '../utils/format';
export function Brands() {
  const {
    brands,
    vehicles
  } = useStore();
  return <div className="container-x py-8 lg:py-12" data-id="element-1234" data-mp="2gco6hkfngq2d">
      <h1 className="font-display text-3xl font-black tracking-tight sm:text-4xl" data-id="element-1235" data-mp="2bcs1piz4oulr">Marcas</h1>
      <p className="mt-2 text-mist" data-id="element-1236" data-mp="380y21tp0p0u8">Explorá los modelos 0 km de cada marca, con sus condiciones y promociones verificadas.</p>
      <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-1237" data-mp="3417hi7q33gy5">
        {brands.map(b => {
        const list = vehicles.filter(v => v.published && v.brandId === b.id);
        const from = list.length ? Math.min(...list.map(v => v.price)) : null;
        return <li key={b.id} data-id="element-1238" data-mp="3rqrywm6la65b">
              <Link to={`/marcas/${b.slug}`} className="group grid items-center gap-3 py-6 transition-colors duration-150 hover:bg-white/[0.02] sm:grid-cols-[220px_1fr_auto] sm:gap-6 sm:px-2" data-id="element-1239" data-mp="3rs31iioat7uu">
                <span className="font-display text-2xl font-bold" data-id="element-1240" data-mp="f89gkxjppbjy">{b.name}</span>
                <span className="text-sm text-mist" data-id="element-1241" data-mp="k4rlpyiyfbwt">
                  {b.tagline}
                  <span className="block text-xs" data-id="element-1242" data-mp="6d381qt24fdq">
                    {list.length} versiones{from !== null ? ` · desde ${formatARS(from)}` : ''}
                  </span>
                </span>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-neon" data-id="element-1243" data-mp="3sk1euh4v96sg">
                  Ver modelos <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden data-id="element-1244" data-mp="1fkzw2mv646s" />
                </span>
              </Link>
            </li>;
      })}
      </ul>
    </div>;
}